var _circle, _rect, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 99,
    viewBox: "0 0 107 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1597,
    cy: 38.1597,
    r: 33.6597,
    stroke: "#BE1E2D",
    strokeWidth: 9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.958,
    y: 61.3843,
    width: 69.1868,
    height: 7.13266,
    transform: "rotate(-47 11.958 61.3843)",
    fill: "#BE1E2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 85.1839C105.5 89.3236 104.658 91.9466 103.35 93.649C102.058 95.3311 100.145 96.3288 97.5266 96.8726C94.8795 97.4224 91.6598 97.4778 87.9217 97.3789C86.6732 97.3458 85.3624 97.2953 84.0054 97.243C81.3713 97.1414 78.5631 97.0331 75.6981 97.0331C72.8331 97.0331 70.0248 97.1414 67.3908 97.243C66.0337 97.2953 64.7229 97.3458 63.4744 97.3789C59.7364 97.4778 56.5166 97.4224 53.8695 96.8726C51.251 96.3288 49.3381 95.3311 48.0458 93.649C46.738 91.9466 45.8965 89.3236 45.8965 85.1839C45.8965 68.7249 59.2391 55.3823 75.6981 55.3823C92.157 55.3823 105.5 68.7249 105.5 85.1839Z",
    fill: "#1BA397",
    stroke: "white",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6981,
    cy: 51.1205,
    r: 15.4921,
    fill: "#1BA397",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/noUser.18456d8cb1f5b3938fcc338fb79131aa.svg";
export { ForwardRef as ReactComponent };